export const pageStyles = {
    containerGrid: {
        display: 'flex',
        justifyContent: 'space-between',
        mb: 2,
    },
    addItemGrid: {
        mb: { xs: 4, md: 0 },
        display: 'flex',
    },
    infoCardGrid: {
        mb: { xs: 4, md: 0 },
        display: 'flex',
    },
};
